
export function addZero(n){

  if(n.length == 2) return n;

  if (Number(n) < 10)
  {
    n = "0" + n;
  }

  return n;

}

export function dateToStr(d) {
		var now = d || new Date();

		var M = addZero((now.getMonth() + 1).toString());

		var d = addZero(now.getDate().toString());

		var y = addZero(now.getFullYear().toString());

		var h = addZero(now.getHours().toString());

		var m = addZero(now.getMinutes().toString());

		return y + M + d + h + m;
	}


export function strToDate(str) {
  var y = str.substring(0, 4),
    M = str.substring(4, 6),
    d = str.substring(6, 8);

  var h = str.substring(8, 10),
    m = str.substring(10, 12),
    s = str.substring(12, 14) || 0;

  return new Date(y, M - 1, d, h, m, s);
}


export function utcStrToDate(str: string){
  let date = strToDate(str);

  let n: any = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());

    n = new Date(n);

    n = new Date(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds());

  return n;
}

export function formatPhoneNumber(phone: string | null | undefined) {
  if (phone) {
    let cleaned = ('' + phone).replace(/\D/g, '');
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      let intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
  }
  return '';
}
export async function uuidv4(): Promise<string> {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  })
}

export function timestampPrepare(time: string | undefined) {
  if (!time || time.length !== 14) return ''
  return (
    time.slice(0, 4) +
    "-" +
    time.slice(4, 6) +
    "-" +
    time.slice(6, 8) +
    " " +
    time.slice(8, 10) +
    ":" +
    time.slice(10, 12) +
    ":" +
    time.slice(12, 14)
  )
}
export function timestampPrepareDate(time: string) {

  time = dateToStr(utcStrToDate(time)) + '00'; 

  if (!time || time.length !== 14) return "";
  
  var y = time.substring(0, 4),
    m = time.substring(4, 6),
    d = time.substring(6, 8);

  var h = time.substring(8, 10),
    _m = time.substring(10, 12)

  var ms = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  var res = y;

  if (m)
    // @ts-ignore
    res += ` ${ms[m - 1]}`
  if (d)
    res += ' ' + d;

  if (h) {
    res += ', ' + h;

    if (_m)
      res += ':' + _m;

    else
    {
      res += 'H';
    }
  }

  return res;
  return (
    time.slice(0, 4) +
    "-" +
    time.slice(4, 6) +
    "-" +
    time.slice(6, 8) +
    " "
  );
}
